import * as React from "react";
import ActionEditorLink from "./components/ActionEditor/ActionEditor";
import { isAuthenticated, useIsAuthenticated } from "./components/AuthHelper/AuthHelper";
import AuthHelperComponent from "./components/AuthHelper/AuthHelperComponent";
import FileUploader from "./components/FileUploader/FileUploader";
import { IconEditor, generateIconClass, generateIconProp, generateIconPropAsSting } from "./components/icon-selector/IconEditor";
import { ImagePicker, ImagePickerModal } from "./components/ImagePicker/ImagePicker";
import PillInput, { Pill } from "./components/PillInput/PillInput";
import { RichMarkdownEditor } from "./components/RichEditor/RichMarkdownEditor";


(window as any).LucyCommonComponents = {
    isAuthenticated: isAuthenticated,
    useIsAuthenticated: useIsAuthenticated,
    AuthHelperComponent: AuthHelperComponent,
    PillInput: PillInput,
    Pill: Pill,
    FileUploader: FileUploader,
    ImagePicker: ImagePicker,
    ImagePickerModal: ImagePickerModal,
    RichMarkdownEditor: RichMarkdownEditor,
    IconEditor: IconEditor,
    ActionEditorLink,
    generateIconClass: generateIconClass,
    generateIconProp: generateIconProp,
    generateIconPropAsSting: generateIconPropAsSting
}

console.log("common components", (window as any).LucyCommonComponents)